module.exports = __webpack_public_path__ + "static/img/1@2x.c244ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barometer/1@2x.png
// module id = oOXY
// module chunks = 1